import cx from 'classnames'
import React, { MouseEvent, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

const LoadMore = React.forwardRef<
  HTMLAnchorElement,
  {
    isLoading?: boolean
    hidden?: boolean
    onClick?: (e?: MouseEvent) => void
    loadingContent?: ReactNode
    className?: string
  }
>((props, ref) => {
  const { t } = useTranslation()

  const {
    isLoading,
    hidden,
    onClick = () => {},
    loadingContent = t('common.loading'),
    className = '',
    ...restProps
  } = props

  return (
    <a
      ref={ref}
      className={cx('LoadMore', className, {
        'LoadMore--hidden': hidden,
        'LoadMore--disabled': isLoading,
      })}
      onClick={onClick}
      {...restProps}
    >
      {isLoading ? loadingContent : t('common.load_more')}
    </a>
  )
})

export default LoadMore
